import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

function RuleAccordion({ rule }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <article className="overflow-hidden rounded-[1.5rem] border border-slate-200 bg-slate-50 dark:border-white/10 dark:bg-white/[0.04]">
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left"
      >
        <span className="font-titre text-lg font-bold text-slate-950 dark:text-white">
          {rule.title}
        </span>

        <FaChevronDown
          className={`shrink-0 text-slate-400 transition ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {isOpen && (
        <div className="space-y-3 border-t border-slate-200 px-4 py-4 dark:border-white/10">
          {rule.paragraphs?.map((paragraph, index) => (
            <p
              key={`${rule.title}-paragraph-${index}`}
              className="text-sm font-medium leading-7 text-slate-600 dark:text-white/60"
            >
              {paragraph}
            </p>
          ))}

          {rule.bullets?.length > 0 && (
            <ul className="space-y-2">
              {rule.bullets.map((bullet, index) => (
                <li
                  key={`${rule.title}-bullet-${index}`}
                  className="flex gap-2 text-sm font-medium leading-6 text-slate-600 dark:text-white/60"
                >
                  <span className="mt-1 text-amber-500">●</span>
                  <span>{bullet}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </article>
  );
}

export default RuleAccordion;